import { home } from "@/content";
import { Rich } from "@/lib/rich";

export default function LightServices() {
  const { services } = home;

  return (
    <section id="services" className="py-24 bg-white dark:bg-[#0E0E0E] relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[5%] left-[-5%] w-[450px] h-[450px] rounded-full bg-amber-200/25 dark:bg-amber-500/10 blur-[140px]" />
        <div className="absolute bottom-[10%] right-[-3%] w-[400px] h-[400px] rounded-full bg-violet-300/20 dark:bg-violet-500/10 blur-[130px]" />
        <div className="absolute top-[40%] left-[30%] w-[300px] h-[300px] rounded-full bg-green-300/15 dark:bg-green-500/10 blur-[120px]" />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-stone-100 dark:bg-white/[0.06] text-stone-600 dark:text-white/70 text-xs font-semibold tracking-widest uppercase mb-4">
            {services.badge}
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900 dark:text-white mb-4">
            <Rich text={services.title} accentClassName="text-orange-700 dark:text-orange-400" />
          </h2>
          {services.subtitle && (
            <p className="text-stone-600 dark:text-white/65 text-lg max-w-2xl mx-auto">
              {services.subtitle}
            </p>
          )}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.items.map((item) => (
            <div
              key={item.title}
              className="group bg-white dark:bg-white/[0.04] border border-stone-100 dark:border-white/[0.08] rounded-2xl p-8 dark:backdrop-blur-xl hover:-translate-y-1 hover:border-stone-300 dark:hover:border-white/[0.16] hover:shadow-[0_8px_30px_rgba(0,0,0,0.04)] transition-all duration-300 cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-stone-900 dark:bg-orange-500 mb-5">
                <i className={`${item.icon} text-white dark:text-[#0A0A0A] text-xl`}></i>
              </div>
              <div className="inline-block px-3 py-1 rounded-full bg-stone-100 dark:bg-white/[0.06] text-stone-600 dark:text-white/70 text-[11px] font-semibold mb-3">
                {item.tag}
              </div>
              <h3 className="text-lg font-bold text-stone-900 dark:text-white mb-3">{item.title}</h3>
              <p className="text-stone-600 dark:text-white/65 text-sm leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
